/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import InlineSelect from 'loracoms/InlineSelect';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  Modal,
  Button,
  Row,
  Col,
  FormControl,
} from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import ErrorSet from 'lorautils/errors/ErrorSet';
import roadrestActions from 'loraactions/roadtest';
import greenImg from '../../images/green.svg';
import redImg from '../../images/red.svg';
import yellowImg from '../../images/yellow.svg';
import orangeImg from '../../images/orange.svg';
import higherImg from '../../images/higher.svg';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showGpsModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  getGpsColor: PropTypes.func.isRequired,
  colorState: PropTypes.object.isRequired,
};

const kDps = ['snr', 'rssi'];

class GpsColor extends React.Component {
  constructor(props) {
    super(props);
    const { green, yellow, red, type } = props.colorState;
    this.state = {
      showGpsModal: props.showGpsModal,
      touched: new Set(),
      by: type,
      errors: ErrorSet.createEmpty(),
      green,
      yellow,
      red,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.handleSession = this.handleSession.bind(this);
  }

  componentWillMount() {
    this.handleValue();
  }

  componentWillReceiveProps(nextProps) {
    const { showGpsModal } = nextProps;
    if (showGpsModal !== this.props.showGpsModal) {
      this.setState({ showGpsModal });
    }
  }

  handleValue() {
    const { icon } = JSON.parse(sessionStorage.getItem('roadtest')) || {};

    const defaultValue = { min: null, max: null };

    if (icon) {
      this.props.getGpsColor(icon);
      const green = icon.green || defaultValue;
      const yellow = icon.yellow || defaultValue;
      const red = icon.red || defaultValue;
      const by = icon.type || kDps[0];
      this.setState({ green,
        yellow,
        red,
        by,
        errors: ErrorSet.createEmpty(),
      });
    }
  }

  touchAll() {
    const { touched } = this.state;
    this.setState({
      touched: (
        touched
          .add('green.min')
          .add('green.max')
          .add('yellow.min')
          .add('yellow.max')
          .add('red.min')
          .add('red.max')),
    });
  }

  handleChangeBy(by) {
    this.setState({ by });
    let green = {};
    let yellow = {};
    let red = {};

    if (by === 'rssi') {
      green = { min: '-95', max: '-60' };
      yellow = { min: '-105', max: '-95' };
      red = { min: '-115', max: '-105' };
    } else if (by === 'snr') {
      green = { min: '0', max: '30' };
      yellow = { min: '-5', max: '0' };
      red = { min: '-10', max: '-5' };
    }
    this.setState({ green, yellow, red, by });
  }

  handleChangeMin(e, key) {
    const { errors, touched } = this.state;
    let values = this.state[key];
    const min = e.target.value;
    if (min.length === 0) {
      this.setState({
        errors: errors.add('FE_EMPTY', `${key}.min`),
      });
    } else {
      const max = values.max;
      if (!_.isNil(max) && Number(min) > Number(max)) {
        this.setState({
          errors: errors.add('FE_WRONG_MIN', `${key}.min`),
          touched: touched.add(`${key}.min`),
        });
      } else {
        this.setState({ errors: errors.remove(`${key}.min`) });
      }
    }
    values = { ...values, min };
    this.setState({ [key]: values });
  }

  handleChangeMax(e, key) {
    const { errors, touched } = this.state;
    let values = this.state[key];
    const max = e.target.value;
    if (max.length === 0) {
      this.setState({
        errors: errors.add('FE_EMPTY', `${key}.max`),
      });
    } else {
      const min = values.min;
      if (!_.isNil(min) && Number(max) < Number(min)) {
        this.setState({
          errors: errors.add('FE_WRONG_MAX', `${key}.max`),
          touched: touched.add(`${key}.max`),
        });
      } else {
        this.setState({ errors: errors.remove(`${key}.max`) });
      }
    }
    values = { ...values, max };
    this.setState({ [key]: values });
  }

  handleOnHide() {
    this.handleValue();
    this.setState({ touched: new Set() });
    this.props.onHide();
  }

  handleOnSubmit() {
    const { errors, green, yellow, red, by } = this.state;
    const { onHide, getGpsColor } = this.props;
    this.touchAll();
    if (!errors.isEmpty()) {
      return;
    }
    const icon = Object.assign({}, { green, yellow, red, type: by });
    onHide();
    getGpsColor(icon);
    this.handleSession(icon);
  }

  handleSession(icon) {
    let roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = { ...roadtest, icon };
    sessionStorage.setItem('roadtest', JSON.stringify(roadtest));
  }

  render() {
    const {
      showGpsModal = false,
      by,
      errors,
      green,
      yellow,
      red,
      touched,
    } = this.state;
    const { onHide } = this.props;
    const options = _.map(kDps, item => ({
      label: item,
      value: item,
    }));

    return (
      <Modal
        show={showGpsModal}
        onHide={onHide}
        bsClass="aisz-modal-light"
      >
        <Modal.Body styleName="input-area" >
          <Row styleName="row-m">
            <Col md={2}>{this.intlMsg.msg('gps.colorset.title1')}</Col>
            <Col md={10}>
              <InlineSelect
                bsStyle="aisz-primary"
                options={options}
                values={[by]}
                onChange={selected => this.handleChangeBy(selected[0])}
              />
            </Col>
          </Row>
          <Row styleName="row-m">
            <Col md={2}>{this.intlMsg.msg('gps.colorset.title2')}</Col>
            <Col md={10}>
              <i
                className="fa fa-exclamation-circle"
                styleName="tip-icon gray"
              />
              <span styleName="tip gray">
                {this.intlMsg.msg('gps.colorset.tip')}
              </span>
            </Col>
          </Row>
          <Row styleName="row-m gray">
            <Col md={1} mdOffset={2}>
              <img src={higherImg} alt="default Icon" width="25" />
            </Col>
            <Col md={3} styleName="line-h ">
              {this.intlMsg.msg('gps.colorset.higher')}
            </Col>
          </Row>
          <Row styleName="row-m gray">
            <Col md={1} mdOffset={2}>
              <img src={greenImg} alt="Green Icon" width="25" />
            </Col>
            <Col md={3}>
              <FormControl
                value={green.min}
                type="number"
                className="aisz-form-control-f"
                placeholder="最小值"
                onChange={e => this.handleChangeMin(e, 'green')}
              />
              <ControlTips
                show={touched.has('green.min') && errors.has('green.min')}
                message={this.intlMsg.errorMsg(errors.get('green.min'))}
                azStyle="danger"
                placement="top"
              />
            </Col>
            <span className="pull-left">-</span>
            <Col md={3}>
              <FormControl
                value={green.max}
                type="number"
                className="aisz-form-control-f"
                placeholder="最大值"
                onChange={e => this.handleChangeMax(e, 'green')}
              />
              <ControlTips
                show={touched.has('green.max') && errors.has('green.max')}
                message={this.intlMsg.errorMsg(errors.get('green.max'))}
                azStyle="danger"
                placement="top"
              />
            </Col>
          </Row>
          <Row styleName="row-m gray">
            <Col md={1} mdOffset={2}>
              <img src={yellowImg} alt="Green Icon" width="25" />
            </Col>
            <Col md={3}>
              <FormControl
                value={yellow.min}
                type="number"
                className="aisz-form-control-f"
                placeholder="最小值"
                onChange={e => this.handleChangeMin(e, 'yellow')}
              />
              <ControlTips
                show={touched.has('yellow.min') && errors.has('yellow.min')}
                message={this.intlMsg.errorMsg(errors.get('yellow.min'))}
                azStyle="danger"
                placement="top"
              />
            </Col>
            <span className="pull-left">-</span>
            <Col md={3}>
              <FormControl
                value={yellow.max}
                type="number"
                className="aisz-form-control-f"
                placeholder="最大值"
                onChange={e => this.handleChangeMax(e, 'yellow')}
              />
              <ControlTips
                show={touched.has('yellow.max') && errors.has('yellow.max')}
                message={this.intlMsg.errorMsg(errors.get('yellow.max'))}
                azStyle="danger"
                placement="top"
              />
            </Col>
          </Row>
          <Row styleName="row-m gray">
            <Col md={1} mdOffset={2}>
              <img src={orangeImg} alt="Green Icon" width="25" />
            </Col>
            <Col md={3} >
              <FormControl
                value={red.min}
                type="number"
                className="aisz-form-control-f"
                placeholder="最小值"
                onChange={e => this.handleChangeMin(e, 'red')}
              />
              <ControlTips
                show={touched.has('red.min') && errors.has('red.min')}
                message={this.intlMsg.errorMsg(errors.get('red.min'))}
                azStyle="danger"
                placement="top"
              />
            </Col>
            <span className="pull-left">-</span>
            <Col md={3}>
              <FormControl
                value={red.max}
                type="number"
                className="aisz-form-control-f"
                placeholder="最大值"
                onChange={e => this.handleChangeMax(e, 'red')}
              />
              <ControlTips
                show={touched.has('red.max') && errors.has('red.max')}
                message={this.intlMsg.errorMsg(errors.get('red.max'))}
                azStyle="danger"
                placement="top"
              />
            </Col>
          </Row>
          <Row styleName="row-m gray">
            <Col md={1} mdOffset={2}>
              <img src={redImg} alt="default Icon" width="25" />
            </Col>
            <Col md={3} styleName="line-h ">
              {this.intlMsg.msg('gps.colorset.other')}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="aisz-success" onClick={() => this.handleOnSubmit()}>
            {this.intlMsg.msg('confirm')}
          </Button>
          <Button
            bsStyle="aisz-default"
            styleName="font-white"
            onClick={() => this.handleOnHide()}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

}

GpsColor.propTypes = propTypes;

const mapStateToProps = state => ({
  colorState: state.roadtest.getGpsColor,
});

const mapDispatchToProps = {
  getGpsColor: roadrestActions.getGpsColor,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(GpsColor,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/GpsColor/index.jsx